import styled from "styled-components";
import { Button } from "antd";

export const Container = styled.div`
  width: 100%;
  height: 108px;
  border-top: 0.5px solid rgba(24, 35, 83, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 17px 32px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  width: ${({ theme }) => theme?.buttons?.submit?.width};
  height: ${({ theme }) => theme?.buttons?.submit?.height};
  padding: ${({ theme }) => theme?.buttons?.submit?.padding};
  background: ${({ theme }) => theme?.buttons?.submit?.background};
  box-shadow: ${({ theme }) => theme?.buttons?.submit?.shadow};
  border-radius: ${({ theme }) => theme?.buttons?.submit?.radius};
  font-style: normal;
  font-weight: ${({ theme }) => theme?.buttons?.submit?.weight};
  font-size: ${({ theme }) => theme?.buttons?.submit?.fontSize};
  line-height: ${({ theme }) => theme?.buttons?.submit?.lineHeight};
  text-transform: capitalize;
  color: ${({ theme }) => theme?.buttons?.submit?.color};
  border: none;

  &.ant-btn-default {
    &:not(:disabled):not(.ant-btn-disabled):hover {
      background-color: ${({ theme }) =>
        theme?.buttons?.submit?.hover?.background};
      border: none;
      color: ${({ theme }) => theme?.buttons?.submit?.hover?.color};
    }

    &:not(:disabled):not(.ant-btn-disabled):focus {
      background-color: ${({ theme }) =>
        theme?.buttons?.submit?.focus?.background};
      border: ${({ theme }) => theme?.buttons?.submit?.focus?.border};
      color: ${({ theme }) => theme?.buttons?.submit?.focus?.color};
    }

    &:disabled {
      background-color: ${({ theme }) =>
        theme?.buttons?.submit?.disabled?.background};
      color: ${({ theme }) => theme?.buttons?.submit?.disabled?.color};
      border-color: ${({ theme }) => theme?.buttons?.submit?.disabled?.border};
      opacity: ${({ theme }) => theme?.buttons?.submit?.disabled?.opacity};
    }
  }
`;

export const TextButton = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: 20px;
  color: ${({ theme }) => theme.pallette.silver.primary};
  margin-top: 8px;
`;
